define('app/factories/newsletter_finished_factory',['app/setup', 'app/models/subscriber', 'app/views/newsletter_finished_view'],
  function(takhfifan, subscriber, dummy_view) {

    $('.finish-cnt').each(function(){
      new takhfifan.NewsletterFinishedView({
        el: $(this),
        model: new takhfifan.Subscriber()
      });
    });
});

